import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { AlertTriangle, X } from "lucide-react";

const HaftungshinweisBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(true), 800);
    return () => window.clearTimeout(timer);
  }, []);

  const dismiss = () => setVisible(false);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.98 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 z-40 mx-auto sm:bottom-6 sm:left-auto sm:right-6 sm:max-w-md"
        >
          <div className="surface-panel-strong relative border-l-4 border-l-destructive bg-destructive/[0.06] p-4 pr-11 shadow-2xl shadow-destructive/10 sm:p-5 sm:pr-12">
            <button
              type="button"
              onClick={dismiss}
              aria-label="Hinweis schließen"
              className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-full border border-white/10 bg-background/60 text-foreground transition-colors hover:bg-background sm:right-3 sm:top-3"
            >
              <X className="h-4 w-4" />
            </button>

            <div className="flex items-start gap-3">
              <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-destructive/15 sm:h-9 sm:w-9">
                <AlertTriangle className="h-4 w-4 text-destructive sm:h-5 sm:w-5" />
              </div>
              <div className="space-y-2">
                <h3 className="font-display text-xs font-bold uppercase tracking-wide text-destructive sm:text-sm">
                  Wichtiger Haftungshinweis
                </h3>
                <p className="text-xs leading-relaxed text-muted-foreground sm:text-sm">
                  Die Verantwortung für die fachgerechte Nachbehandlung des Betons liegt vollständig beim Kunden.
                  Beton2Go Romano übernimmt keine Haftung für Schäden, die durch falsche oder fehlende
                  Nachbehandlung entstehen.
                </p>
                <p className="text-xs text-muted-foreground sm:text-sm">
                  Weitere Informationen finden Sie hier unter{" "}
                  <Link
                    to="/betoninfos"
                    onClick={dismiss}
                    className="font-medium text-primary underline-offset-2 hover:underline"
                  >
                    Betoninfos
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HaftungshinweisBanner;
